import { Breadcrumb, Layout, Image, Row, Col, message, Modal, Upload, Carousel, Input, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import { RollbackOutlined, HeartOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons';
import ClassLessonModal from './ClassLesson';
import Carousel_news_ticker from './Carousel_news_ticker';
const ClassIntroduceContent = ({
    content_visible = false
}) => {
    const [open, setOpen] = useState(false)
    const navigate = useNavigate();
    const { Id } = useParams();
    const { lesson_id } = useParams();
    const [data, setData] = useState({});
    const [class_data, set_class_data] = useState([]);
    const [file_url, set_file_url] = useState([]);
    const [lesson_file_url, set_lesson_file_url] = useState([]);
    const [editcard, setEditCard] = useState({});
    const [permission, setPermission] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    useEffect(() => {
        let source = window.location.pathname.split('/')[2];
        // console.log(source)
        if (source == 'ClassIntroduce') {
            // set_blog_type_id(5);
            get_data();
        } else if (source == 'News') {
            // set_blog_type_id(1);
            get_news();
        } else if (source == 'ShareLearning') {
            // set_blog_type_id(1);
            get_shareLearning();
        } else if (source == 'Class') {
            get_class();
            // set_blog_type_id(3);
        }
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
    }, [])
    const get_shareLearning = () => {
        axios
            .get('/cramSchool/api/learn_witness/per', { params: { "learn_witness_id": Id } })
            .then((response) => {
                setData(response.data[0]);
                get_picture(response.data[0], setData);
            })
    }
    const get_news = () => {
        axios
            .get('/cramSchool/api/blog/lastest', { params: { "blog_id": Id } })
            .then((response) => {
                setData(response.data.data[0]);
                get_picture(response.data.data[0], setData);
            })
    }
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/lesson_category', { params: { "blog_id": Id } })
            .then((response) => {
                setData(response.data.data[0]);
                console.log(lesson_id);
                if (lesson_id != undefined) {
                    let data_tmp = response.data.data[0].class_data.filter(item => item.lesson_id == lesson_id)
                    // console.log(data_tmp);
                    set_class_data(data_tmp);
                    get_picture(data_tmp, set_class_data);
                } else {
                    set_class_data(response.data.data[0].class_data)
                    get_picture(response.data.data[0].class_data, set_class_data);
                }
            })
    }
    const get_class = () => {
        axios
            .get('/cramSchool/api/blog/tidbits', { params: { "blog_id": Id } })
            .then((response) => {
                setData(response.data.data[0]);
                get_picture(response.data.data[0], setData);
            })
    }
    const get_picture = (data_tmp, set_function) => {
        data_tmp && data_tmp.map((value, index) => {
            let file_id = value['file_id']
            if (value.file_id) {
                value.file_id.map((tmp, key) => {
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            set_function(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (file_id == value.file_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )
                        })
                })
            }
        })

    }
    const handleEdit = (file_id) => {
        axios
            .patch(`/cramSchool/api/class`, [{ ...editcard, file_id }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_data();
                }
            })
    }
    // useEffect(() => {
    //     console.log(class_data)
    // }, [class_data])
    return (
        <>
            {contextHolder}
            <ClassLessonModal
                open={open}
                edit={true}
                title={'修改班級'}
                color={'f09a45'}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
            />
            <Row gutter={[16, 24]} justify='center'>
                <Col span={24}>
                    <RollbackOutlined className='example' style={{ fontSize: '30px' }} onClick={e => navigate(-1)} />
                </Col>
                <Col span={24} >
                    {/* <Col md={{ span: 6 }} sm={{ span: 8 }} > */}
                    <Row align={'middle'} style={{ position: 'relative' }}>
                        <Col style={{ fontSize: '2.5rem', background: '#fcedfe', padding: '10px', zIndex: 99 }}>{data?.title}</Col>
                        <Col style={{ background: '#cf4da6', zIndex: 1, position: 'absolute', top: '8px', left: '10px', padding: '10px', fontSize: '2.5rem' }}>{data?.title}</Col>
                    </Row>
                    {/* </Col> */}
                </Col>
                <Col span={12}>
                    <Row gutter={[8, 8]}>
                        <Col span={20} style={{ fontSize: '1.2rem' }}>
                            {data?.student_name}
                        </Col>
                        <Col span={20} style={{ fontSize: '1.2rem' }}>
                            {data?.['content'] && (<>
                                {(String(data?.['content']) || '').split('\n').map(map_item => (<>
                                    {map_item}<br />
                                </>))}
                            </>)}
                        </Col>
                        <Col span={22}>
                            <Carousel_news_ticker file_url={file_url} />
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <span dangerouslySetInnerHTML={{ __html: data?.more_content }}></span>
                </Col >
                {(class_data || []).map(map_item => {
                    return (<>
                        <Col span={24}>
                            <Row gutter={[24, 8]}>
                                <Col md={{ span: 12 }} sm={{ span: 24 }} style={{ justifyContent: 'center', alignItems: 'center' }}>
                                    <Carousel_news_ticker file_url={map_item['file_url']} height={"15rem"} />
                                </Col>
                                <Col md={{ span: 12 }} sm={{ span: 24 }} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Row justify={'center'}>
                                        <Col span={24} style={{ position: 'relative' }}>
                                            <p style={{ fontSize: '2.5rem' }}>{map_item?.name}</p>
                                        </Col>
                                        <Col span={24}>
                                            <p style={{ fontSize: '1.3rem' }}>{map_item['content']}</p>
                                        </Col>
                                        {(content_visible) && (<>
                                            <Col span={24}>
                                                <p style={{ fontSize: '1.3rem' }}>授課老師: {map_item?.class_teachers.join('、')}</p>
                                            </Col>
                                            <Col span={24}>
                                                <p style={{ fontSize: '1.1rem' }}>目前上課人數: {map_item?.student_count} 人</p>
                                            </Col>
                                        </>)}
                                        {permission ? <>
                                            <Col style={{ position: 'absolute', top: '0px', right: '0px' }}>
                                                <Row justify={'end'}>
                                                    <EditOutlined
                                                        className='example'
                                                        style={{
                                                            backgroundColor: '#F9D4E5',
                                                            fontSize: '1.2rem',
                                                            borderRadius: '50%',
                                                            padding: '8px'
                                                        }}
                                                        onClick={(e) => { setEditCard(map_item); setOpen(true) }}
                                                    />
                                                </Row>
                                            </Col>
                                        </> : null}
                                    </Row>
                                </Col>

                            </Row>
                        </Col>
                    </>)
                })}
            </Row >
        </>
    )
}
export default ClassIntroduceContent;